import { useState } from "react";
import { api } from "../lib/api.js";
import { Modal } from "./ui.js";

function localDate(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

function Scale({ label, value, onChange, lowLabel, highLabel }: { label: string; value: number | null; onChange: (v: number | null) => void; lowLabel?: string; highLabel?: string }) {
  return (
    <div className="field">
      <label>{label}</label>
      <div className="scale-row">
        {[1, 2, 3, 4, 5].map((n) => (
          <button key={n} type="button" className={`scale-dot${value === n ? " selected" : ""}`} onClick={() => onChange(value === n ? null : n)}>{n}</button>
        ))}
      </div>
      {(lowLabel || highLabel) && (
        <div className="row-between dim text-xs"><span>{lowLabel}</span><span>{highLabel}</span></div>
      )}
    </div>
  );
}

/** The fast evening companion to the morning readiness check. Not diagnostic. */
export function EveningCheckinModal({ onClose, onSaved }: { onClose: () => void; onSaved: () => void }) {
  const [energy, setEnergy] = useState<number | null>(null);
  const [hunger, setHunger] = useState<number | null>(null);
  const [mood, setMood] = useState<number | null>(null);
  const [difficulty, setDifficulty] = useState<number | null>(null);
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);

  async function save() {
    setSaving(true);
    try {
      await api.put("/api/checkins/evening", { date: localDate(), energy, hunger, mood, difficulty, note: note.trim() || null });
      onSaved();
    } catch { setSaving(false); }
  }

  return (
    <Modal title="Evening check-in" onClose={onClose}>
      <p className="muted text-sm" style={{ marginTop: 0 }}>How did today go? A few taps — all optional.</p>
      <Scale label="Energy" value={energy} onChange={setEnergy} lowLabel="Drained" highLabel="Energized" />
      <Scale label="Hunger" value={hunger} onChange={setHunger} lowLabel="Low" highLabel="High" />
      <Scale label="Mood" value={mood} onChange={setMood} lowLabel="Low" highLabel="Great" />
      <Scale label="How hard did today feel?" value={difficulty} onChange={setDifficulty} lowLabel="Easy" highLabel="Tough" />
      <div className="field">
        <label htmlFor="ev-note">Anything worth noting? <span className="dim">(optional)</span></label>
        <textarea id="ev-note" className="textarea" rows={2} value={note} onChange={(e) => setNote(e.target.value)} maxLength={1000} placeholder="A win, a struggle, something to remember…" />
      </div>
      <div className="row mt-4">
        <button className="btn btn-primary grow" onClick={save} disabled={saving}>{saving ? "Saving…" : "Save check-in"}</button>
        <button className="btn" onClick={onClose} disabled={saving}>Cancel</button>
      </div>
    </Modal>
  );
}
